import React, { useEffect, useRef, useState } from 'react';
import { Container, Dropdown, Nav, Navbar } from 'react-bootstrap';
import styled from 'styled-components';
import { FaUserCircle } from 'react-icons/fa';
import { FiArrowDownRight, FiEdit3, FiX } from 'react-icons/fi';
import LoginModal from './LoginModal';

const SECTION_NAV_ITEMS = [];

const StyledNavbar = styled(Navbar)`
  min-height: 72px;
  padding: 0;
  border-bottom: 1px solid ${({ scrolled }) => (
    scrolled === 'true' ? 'rgba(17, 19, 24, 0.09)' : 'rgba(17, 19, 24, 0.055)'
  )};
  background: ${({ scrolled }) => (
    scrolled === 'true' ? 'rgba(252, 250, 246, 0.94)' : 'rgba(252, 250, 246, 0.84)'
  )};
  box-shadow: ${({ scrolled }) => (
    scrolled === 'true' ? '0 14px 38px rgba(31, 36, 51, 0.075)' : 'none'
  )};
  backdrop-filter: blur(18px) saturate(150%);
  -webkit-backdrop-filter: blur(18px) saturate(150%);
  transition: background 220ms ease, border-color 220ms ease, box-shadow 220ms ease;
  z-index: 2000;

  > .container {
    min-height: 72px;
  }

  .navbar-brand {
    display: inline-flex;
    align-items: center;
    min-height: 44px;
    padding: 0;
  }

  .navbar-brand img {
    display: block;
    width: auto;
    height: 20px;
    margin: 0;
    filter: brightness(0) saturate(100%);
    opacity: 0.92;
  }

  .navbar-nav {
    gap: 8px;
  }

  .apply-btn {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 46px;
    margin-left: 0 !important;
    padding: 0 18px !important;
    border: 1px solid rgba(17, 19, 24, 0.12) !important;
    border-radius: 14px !important;
    background: #111318 !important;
    color: #fff !important;
    box-shadow: 0 10px 24px rgba(17, 19, 24, 0.14), inset 0 1px 0 rgba(255, 255, 255, 0.16);
    font-size: 0.86rem !important;
    font-weight: 780 !important;
    letter-spacing: -0.01em;
    text-shadow: none;
    transition: transform 220ms cubic-bezier(0.22, 1, 0.36, 1), box-shadow 220ms ease, background 220ms ease !important;

    svg {
      color: #8fc4ea;
      transition: transform 220ms ease;
    }

    &:hover,
    &:focus-visible {
      background: #242831 !important;
      color: #fff !important;
      transform: translateY(-2px);
      box-shadow: 0 15px 30px rgba(17, 19, 24, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.16);
      outline: none;
    }

    &:hover svg,
    &:focus-visible svg {
      transform: rotate(-5deg) scale(1.06);
    }
  }

  .header-account > .nav-link,
  .dropdown-toggle.nav-link {
    display: inline-flex;
    align-items: center;
    min-height: 44px;
    padding: 0 12px !important;
    border-radius: 12px;
    color: #2f3540 !important;
    font-size: 0.84rem;
    font-weight: 720;
    text-shadow: none;
  }

  .dropdown-menu {
    padding: 8px;
    border: 1px solid rgba(17, 19, 24, 0.1) !important;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.96) !important;
    box-shadow: 0 22px 55px rgba(31, 36, 51, 0.15);
  }

  .dropdown-item {
    border-radius: 10px;
    color: #323944 !important;
    font-size: 0.86rem;
    font-weight: 680;
  }

  .dropdown-item:hover,
  .dropdown-item:focus {
    background: #edf4fc;
    color: #111318 !important;
  }

  @media (max-width: 991.98px) {
    min-height: 64px;

    > .container {
      min-height: 64px;
    }

    .navbar-brand img {
      height: 18px;
    }

    .navbar-collapse {
      position: fixed;
      inset: 0;
      display: flex !important;
      align-items: center;
      justify-content: center;
      width: 100%;
      min-height: 100vh;
      min-height: 100svh;
      padding: 96px 24px 38px;
      visibility: hidden;
      opacity: 0;
      background:
        radial-gradient(circle at 82% 22%, rgba(100, 167, 236, 0.19), transparent 30%),
        linear-gradient(rgba(17, 19, 24, 0.032) 1px, transparent 1px),
        linear-gradient(90deg, rgba(17, 19, 24, 0.032) 1px, transparent 1px),
        #f7f6f2;
      background-size: auto, 56px 56px, 56px 56px, auto;
      transform: translateY(-16px);
      transition: opacity 240ms ease, visibility 240ms ease, transform 300ms cubic-bezier(0.22, 1, 0.36, 1);
    }

    .navbar-collapse.show {
      visibility: visible;
      opacity: 1;
      transform: translateY(0);
    }

    .navbar-nav {
      width: min(100%, 420px);
      align-items: stretch !important;
      gap: 12px;
    }

    .navbar-nav::before {
      content: 'NARNIA LAB · APPLICATION';
      display: block;
      margin-bottom: 18px;
      color: #6d7784;
      font-size: 0.68rem;
      font-weight: 820;
      letter-spacing: 0.14em;
      text-align: center;
    }

    .apply-btn {
      width: 100%;
      min-height: 58px;
      margin-top: 0 !important;
      border-radius: 17px !important;
      font-size: 1rem !important;
    }

    .dropdown {
      width: 100%;
    }

    .dropdown-toggle.nav-link {
      justify-content: center;
      width: 100%;
      min-height: 50px;
      border: 1px solid rgba(17, 19, 24, 0.1);
      background: rgba(255, 255, 255, 0.62);
    }
  }
`;

const CloseButton = styled.button`
  display: none;

  @media (max-width: 991.98px) {
    position: absolute;
    top: 14px;
    right: max(16px, env(safe-area-inset-right));
    display: grid;
    width: 46px;
    height: 46px;
    place-items: center;
    border: 1px solid rgba(17, 19, 24, 0.11);
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.72);
    color: #111318;
    font-size: 1.25rem;
    box-shadow: 0 10px 28px rgba(31, 36, 51, 0.08);
    z-index: 2100;
  }
`;

const StyledToggle = styled(Navbar.Toggle)`
  width: 46px;
  height: 46px;
  padding: 0 !important;
  border: 1px solid rgba(17, 19, 24, 0.11) !important;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.62) !important;
  box-shadow: none !important;

  .navbar-toggler-icon {
    width: 22px;
    height: 22px;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2817,19,24,0.92%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
  }

  &:hover,
  &:focus-visible {
    border-color: rgba(64, 116, 255, 0.35) !important;
    background: #fff !important;
  }
`;

const FloatingNav = styled.nav`
  position: fixed;
  top: 50%;
  right: var(--floating-ui-right, 1.5rem);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px 4px;
  border: 1px solid rgba(17, 19, 24, 0.08);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.74);
  box-shadow: 0 16px 42px rgba(31, 36, 51, 0.1);
  backdrop-filter: blur(18px) saturate(140%);
  transform: translateY(-50%);
  pointer-events: none;

  @media (max-width: 991.98px) {
    display: none;
  }
`;

const NavItem = styled.a`
  position: relative;
  display: grid;
  width: 38px;
  height: 40px;
  place-items: center;
  border-radius: 13px;
  pointer-events: auto;

  .label {
    position: absolute;
    top: 50%;
    right: calc(100% + 10px);
    padding: 8px 12px;
    border: 1px solid rgba(17, 19, 24, 0.09);
    border-radius: 10px;
    opacity: 0;
    background: rgba(255, 255, 255, 0.96);
    color: #323944;
    box-shadow: 0 12px 30px rgba(31, 36, 51, 0.12);
    font-size: 0.76rem;
    font-weight: 720;
    white-space: nowrap;
    transform: translate(6px, -50%);
    transition: opacity 180ms ease, transform 180ms ease;
    pointer-events: none;
  }

  .label.show-temp {
    opacity: 1;
    transform: translate(0, -50%);
  }

  .dot {
    width: 7px;
    height: 7px;
    border: 0;
    border-radius: 50%;
    background: #9ba5b1;
    transition: transform 180ms ease, background 180ms ease, box-shadow 180ms ease;
  }
`;

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [tempShowLabel, setTempShowLabel] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const labelTimerRef = useRef(null);

  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const MAIN_URL = 'https://narnia-lab.com';

  const showLabelTemporarily = (id) => {
    setTempShowLabel(id);
    if (labelTimerRef.current) clearTimeout(labelTimerRef.current);
    labelTimerRef.current = setTimeout(() => setTempShowLabel(null), 3000);
  };

  const fetchUserInfo = async (token) => {
    try {
      const response = await fetch('/api/me', {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.ok) {
        setUserInfo(await response.json());
      }
    } catch (error) {
      console.error('Failed to fetch user info:', error);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 24);
      const threshold = 250;
      let currentActive = 'home';
      const allSectionIds = ['home', ...SECTION_NAV_ITEMS.map((item) => item.id)];

      for (const id of allSectionIds) {
        const element = document.getElementById(id);
        if (element?.getBoundingClientRect().top <= threshold) currentActive = id;
      }

      setActiveSection(currentActive);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    const storedUser = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    if (storedUser && token) {
      setUser(storedUser);
      fetchUserInfo(token);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (labelTimerRef.current) clearTimeout(labelTimerRef.current);
    };
  }, []);

  const handleNavLinkClick = () => setExpanded(false);

  const handleLogin = (username, token) => {
    localStorage.setItem('user', username);
    localStorage.setItem('token', token);
    setUser(username);
    fetchUserInfo(token);
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    setUser(null);
    setUserInfo(null);
  };

  return (
    <>
      <StyledNavbar
        scrolled={scrolled.toString()}
        expand="lg"
        fixed="top"
        expanded={expanded}
        onToggle={setExpanded}
        aria-label="신청 페이지 주요 메뉴"
      >
        <Container>
          <Navbar.Brand href={MAIN_URL} onClick={() => setExpanded(false)}>
            <img src={`${process.env.PUBLIC_URL}/naniaraeb_white.png`} alt="NARNIA LAB" />
          </Navbar.Brand>
          <StyledToggle aria-controls="apply-navbar-nav" />
          <Navbar.Collapse id="apply-navbar-nav">
            <CloseButton type="button" onClick={() => setExpanded(false)} aria-label="메뉴 닫기">
              <FiX aria-hidden="true" />
            </CloseButton>
            <Nav className="ms-auto align-items-center">
              {SECTION_NAV_ITEMS.map((item) => (
                <Nav.Link key={item.id} href={item.href} onClick={handleNavLinkClick}>
                  {item.label}
                </Nav.Link>
              ))}

              <Nav.Link href="#public-event-apply" className="apply-btn" onClick={handleNavLinkClick}>
                <FiEdit3 size={17} aria-hidden="true" />
                <span>신청하기</span>
                <FiArrowDownRight size={16} aria-hidden="true" />
              </Nav.Link>

              {user && (
                <Dropdown align="end" className="header-account">
                  <Dropdown.Toggle as={Nav.Link} id="apply-account-menu">
                    <FaUserCircle size={19} aria-hidden="true" />
                    <span>{user}님</span>
                    {userInfo && (
                      <span
                        className="d-day-badge"
                        style={{
                          marginLeft: 5,
                          padding: '2px 7px',
                          borderRadius: 999,
                          background: userInfo.role === 'special_member'
                            ? '#6c5ce7'
                            : (userInfo.is_active ? (userInfo.role === 'tester' ? '#347bc0' : '#2f9d71') : '#d95757'),
                          color: '#fff',
                          fontSize: '0.62rem',
                          fontWeight: 800,
                        }}
                      >
                        {userInfo.role === 'special_member'
                          ? 'MEMBER'
                          : (userInfo.is_active
                            ? (userInfo.role === 'tester' ? `TEST D-${userInfo.days_remaining}` : `D-${userInfo.days_remaining}`)
                            : '만료됨')}
                      </span>
                    )}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href={`${MAIN_URL}/mypage`} onClick={handleNavLinkClick}>마이페이지</Dropdown.Item>
                    <Dropdown.Item onClick={() => { handleLogout(); handleNavLinkClick(); }}>로그아웃</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </StyledNavbar>

      {SECTION_NAV_ITEMS.length > 0 && (
        <FloatingNav aria-label="페이지 섹션">
          {SECTION_NAV_ITEMS.map((item) => (
            <NavItem
              key={item.id}
              href={item.href}
              aria-current={activeSection === item.id ? 'location' : undefined}
              onMouseEnter={() => window.innerWidth > 991.98 && showLabelTemporarily(item.id)}
              onClick={() => window.innerWidth > 991.98 && showLabelTemporarily(item.id)}
            >
              <span className={`label ${tempShowLabel === item.id ? 'show-temp' : ''}`}>{item.label}</span>
              <span
                className="dot"
                style={activeSection === item.id ? {
                  background: '#4074ff',
                  transform: 'scale(1.35)',
                  boxShadow: '0 0 0 5px rgba(64, 116, 255, 0.12)',
                } : undefined}
              />
            </NavItem>
          ))}
        </FloatingNav>
      )}

      <LoginModal
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
        onLogin={handleLogin}
      />
    </>
  );
};

export default Header;
